import React from 'react';
import cx from 'classnames';
import { logSessionInfo } from '../../services/logger';

export default function SequencingTile({
  option,
  placed,
  taken,
  playing,
  resting,
  revealed = true,
  pointed,
  disabled,
  onClick,
}) {
  const label = option.text || option.key;
  const content = option.imageUrl ? (
    <img
      className="sequencing__tileImage"
      src={option.imageUrl}
      alt={option.text || ''}
      onError={() => logSessionInfo('image_load_error', { imageUrl: option.imageUrl, screen: 'sequencing', optionKey: option.key })}
    />
  ) : (
    <span className="sequencing__tileText">{label}</span>
  );

  if (!onClick) {
    return (
      <div
        className={cx('sequencing__tile', {
          'sequencing__tile--image': !!option.imageUrl,
          'sequencing__tile--placed': placed,
          'sequencing__tile--revealed': revealed,
        })}
      >
        {content}
      </div>
    );
  }

  return (
    <button
      type="button"
      className={cx('sequencing__tile', 'pointerTarget', 'bottom', {
        'sequencing__tile--image': !!option.imageUrl,
        'sequencing__tile--playing': playing,
        'sequencing__tile--resting': resting,
        'sequencing__tile--revealed': revealed,
        'sequencing__tile--taken': taken,
        showPointer: pointed,
        disabled,
      })}
      onClick={onClick}
      disabled={disabled}
      aria-hidden={taken || undefined}
    >
      {content}
    </button>
  );
}
